export default __webpack_public_path__ + "static/1948-11345ab6d97d0703d50044475da5675d.gif";